var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('svg',{attrs:{"width":"11","height":"16","viewBox":"0 0 11 16","xmlns":"http://www.w3.org/2000/svg"}},[_c('g',{attrs:{"stroke":"#574F76","stroke-width":"3","fill":"none","fill-rule":"evenodd","stroke-linecap":"round"}},[_c('path',{attrs:{"d":"M2 8l7-6.5M2.085 8.188L8.75 13.7"}})])])};var toString = function () {return "/home/runner/work/online-store/online-store/src/assets/icons/common/back.svg"};module.exports = { render: render, toString: toString };


//////////////////
// WEBPACK FOOTER
// ./src/assets/icons/common/back.svg
// module id = HAyt
// module chunks = 18